/**
 * @file: description
 * @author:
 * @Date: 2020-01-19 19:50:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-02-27 11:22:51
 */
import { takeLatest, put } from 'redux-saga/effects';
import { LOCATION_CHANGE } from 'connected-react-router';
import logger from '@tkit/logger';

import { default as doUserModel } from './userModel';
import { default as doFollowModel } from './followModel';
import { default as doArticleModel } from './articleModel';
import { default as dotagModelModel } from './tagModel';
import { default as doEditInfoModel } from './editInfoModel';
import { default as doAskModel } from './askModel';

export const sagaUserModel = doUserModel.sagas;
export function* sagaUserInfo() {
  yield takeLatest(LOCATION_CHANGE, function*() {
    yield put({ type: doUserModel.TYPES.doUserInfo });
  });
}

// eslint-disable-next-line @typescript-eslint/camelcase
export const { loggerSaga } = logger(
  {},
  // eslint-disable-next-line @typescript-eslint/camelcase
  {}
);

export const sagaFollowModel = doFollowModel.sagas;
export const sagaArticleModel = doArticleModel.sagas;
export const sagatagModel = dotagModelModel.sagas;
export const sagaEditInfoModel = doEditInfoModel.sagas;
export const sagaAskModel = doAskModel.sagas;
